import { useAuth } from 'react-oidc-context';
import { useTranslation } from 'react-i18next';
import {
  DropDown,
  DropDownContent,
  IconContainer,
  MenuContainer,
  ProfileContainer,
  ProfileImage,
  StyledHeader,
  TitleContainer,
  VerticalDivider,
} from './Header.Styles';

import NotificationsSharpIcon from '@mui/icons-material/NotificationsSharp';
import KeyboardArrowDownSharpIcon from '@mui/icons-material/KeyboardArrowDownSharp';

const Header = () => {
  const { REACT_APP_REDIRECT_URI } = process.env;

  const auth = useAuth();
  const { t } = useTranslation();
  const group = auth.user.profile['cognito:groups']?.[0];

  return (
    <StyledHeader>
      <TitleContainer />
      <MenuContainer>
        <IconContainer>
          <NotificationsSharpIcon htmlColor="#BCBCCB" />
        </IconContainer>
        <VerticalDivider />
        <ProfileContainer>
          <DropDown>
            <span>{t(group)}</span>
            <DropDownContent className="dropdown-content">
              <button
                onClick={async () => {
                  auth.removeUser();
                  auth.signoutRedirect({
                    extraQueryParams: {
                      redirect_uri: REACT_APP_REDIRECT_URI,
                      response_type: 'code',
                      scope: 'email openid phone',
                    },
                  });
                }}
              >
                Logout
              </button>
            </DropDownContent>
          </DropDown>
          <KeyboardArrowDownSharpIcon htmlColor="#BCBCCB" />
          <ProfileImage
            profileImage={
              'https://static.vecteezy.com/system/resources/thumbnails/003/337/584/small/default-avatar-photo-placeholder-profile-icon-vector.jpg'
            }
          />
        </ProfileContainer>
      </MenuContainer>
    </StyledHeader>
  );
};

export default Header;
